<template>
  <div class="left-tabs-table-view">
    <!-- Tab 切换区域 -->
    <div class="tabs-header">
      <el-tabs v-model="activeTabName" @tab-click="handleTabClick" class="custom-tabs">
        <el-tab-pane label="省区开方量" name="sixth"></el-tab-pane>
        <el-tab-pane label="地办开方量" name="fifth"></el-tab-pane>
        <el-tab-pane label="诊所开方量" name="third"></el-tab-pane>
        <el-tab-pane label="诊所收入" name="fourth"></el-tab-pane>
        <el-tab-pane label="云诊所消沉" name="first"></el-tab-pane>
        <el-tab-pane label="Pad诊所消沉" name="second"></el-tab-pane>
      </el-tabs>
      <!-- <i class="el-icon-info icon-right"></i> -->
    </div>

    <!-- 表格区域 -->
    <div class="table-container">
      <div class="table-header">
        <span class="col-index">序号</span>
        <span v-for="(col, index) in currentTableColumns" :key="index" :class="getColumnClass(index)">
          {{ col }}
        </span>
      </div>
      <div class="table-body" :ref="`tableBody-${activeTabName}`" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
        <div 
          class="table-content" 
          :class="{ 'scrolling': shouldScroll, 'paused': isPaused }"
          :style="scrollAnimationStyle"
        >
          <div class="table-row" v-for="(item, index) in currentTableData" :key="index">
            <span class="col-index">{{ item.index }}</span>
            <span 
              v-for="(key, keyIndex) in currentTableKeys" 
              :key="keyIndex" 
              :class="getColumnClass(keyIndex)"
            >
              {{ getCellValue(item, key) }}
            </span>
          </div>
          <!-- 复制数据用于无缝滚动 -->
          <div class="table-row" v-for="(item, index) in currentTableData" :key="'copy-' + index">
            <span class="col-index">{{ item.index }}</span>
            <span 
              v-for="(key, keyIndex) in currentTableKeys" 
              :key="keyIndex" 
              :class="getColumnClass(keyIndex)"
            >
              {{ getCellValue(item, key) }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftTabsTableView',
  data() {
    return {
      activeTabName: 'sixth',
      shouldScroll: false,
      isPaused: false,
      stat_range_month: 1,
      rowHeight: 0, // 每行高度，用于计算动画
      // 数据存储
      tableData: {
        first: [], // 云诊所消沉
        second: [], // Pad诊所消沉
        third: [], // 诊所开方量
        fourth: [], // 诊所收入
        fifth: [], // 地办开方量
        sixth: [] // 省区开方量
      }
    }
  },
  computed: {
    currentTableColumns() {
      const columnsMap = {
        first: ['诊所名称', '城市', '最近使用时间'],
        second: ['诊所名称', '城市', '最近使用时间'],
        third: ['诊所名称', '城市', '数值'],
        fourth: ['诊所名称', '城市', '数值'],
        fifth: ['地办名称', '所属省区', '处方数(个)'],
        sixth: ['所属省区', '处方数(个)']
      }
      return columnsMap[this.activeTabName] || columnsMap.sixth
    },
    currentTableKeys() {
      const keysMap = {
        first: ['clinic_name', 'city', 'create_time'],
        second: ['clinic_name', 'city', 'create_time'],
        third: ['name', 'city', 'value'],
        fourth: ['name', 'city', 'value'],
        fifth: ['new_diban_name', 'new_shengqu_name', 'cfl'],
        sixth: [ 'new_shengqu_name', 'cfl']
      }
      return keysMap[this.activeTabName] || keysMap.sixth
    },
    currentTableData() {
      return this.tableData[this.activeTabName] || []
    },
    scrollAnimationStyle() {
      if (!this.shouldScroll || this.currentTableData.length === 0) {
        return {}
      }
      const rowCount = this.currentTableData.length
      // 动画时长 = 数据行数秒（每秒滚动一行），使用线性动画实现平滑滚动
      const duration = rowCount
      return {
        animationDuration: `${duration}s`,
        animationTimingFunction: 'linear'
      }
    }
  },
  mounted() {
    // 初始化加载默认 tab 数据
    this.handleTabClick({ name: this.activeTabName })
  },
  watch: {
    activeTabName() {
      this.isPaused = false
      this.$nextTick(() => {
        this.startScroll()
      })
    },
    currentTableData: {
      handler() {
        this.$nextTick(() => {
          this.startScroll()
        })
      },
      deep: true
    }
  },
  methods: {
    handleTabClick(tab) {
      const tabName = tab.name || this.activeTabName
      
      // 如果数据已加载，直接使用
      if (this.tableData[tabName] && this.tableData[tabName].length > 0) {
        this.shouldScroll = false
        this.isPaused = false
        this.$nextTick(() => {
          this.startScroll()
        })
        return
      }

      // 根据不同的 tab 请求不同的接口
      let apiUrl = ''
      if (tabName === 'first') {
        apiUrl = "/recent_absent_clinics_online?stat_range_month=" + this.stat_range_month
      } else if (tabName === 'second') {
        apiUrl = "/recent_absent_clinics_pad?stat_range_month=" + this.stat_range_month
      } else if (tabName === 'third') {
        apiUrl = "/query_kf_rank?stat_range_month=" + this.stat_range_month
      } else if (tabName === 'fourth') {
        apiUrl = "/query_xsl_rank?stat_range_month=" + this.stat_range_month
      } else if (tabName === 'fifth') {
        apiUrl = "/query_cfl_rank_diban?stat_range_month=" + this.stat_range_month
      } else if (tabName === 'sixth') {
        apiUrl = "/query_cfl_rank_shengqu?stat_range_month=" + this.stat_range_month
      }

      if (apiUrl) {
        this.$http.get(process.env.VUE_APP_API_HOST + apiUrl).then((res) => {
          const data = res.data.data || []
          this.tableData[tabName] = data.map((item, index) => ({
            index: index + 1,
            ...item
          }))
          this.shouldScroll = false
          this.isPaused = false
          this.$nextTick(() => {
            this.startScroll()
          })
        }).catch(() => {
          this.tableData[tabName] = []
          this.shouldScroll = false
          this.isPaused = false
        })
      }
    },
    getCellValue(item, key) {
      const value = item[key]
      if (key === 'cfl' || key === 'value') {
        return this.formatNumber(value)
      }
      return value || ''
    },
    getColumnClass(index) {
      // 根据列索引返回对应的 class
      // index 是列在 currentTableColumns 中的索引
      const totalCols = this.currentTableColumns.length
      if (index === totalCols - 1) {
        // 最后一列右对齐
        return 'col-count'
      }
      // 其他列居中
      return 'col-province'
    },
    pauseScroll() {
      this.isPaused = true
    },
    resumeScroll() {
      this.isPaused = false
    },
    startScroll() {
      this.$nextTick(() => {
        const refKey = `tableBody-${this.activeTabName}`
        const tableBody = this.$refs[refKey]
        const bodyElement = Array.isArray(tableBody) ? tableBody[0] : tableBody
        
        if (bodyElement && bodyElement.querySelector) {
          const content = bodyElement.querySelector('.table-content')
          if (content) {
            const contentHeight = content.scrollHeight
            const containerHeight = bodyElement.clientHeight
            
            // 计算每行高度
            const firstRow = content.querySelector('.table-row')
            if (firstRow) {
              this.rowHeight = firstRow.offsetHeight
            }
            
            if (contentHeight > containerHeight && this.currentTableData.length > 0) {
              this.shouldScroll = true
            } else {
              this.shouldScroll = false
            }
          }
        }
      })
    },
    formatNumber(num) {
      if (typeof num === 'number') {
        return num.toLocaleString()
      }
      return num
    }
  }
}
</script>

<style lang="scss" scoped>
.left-tabs-table-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: #fff;
 
  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
    font-size: 14px;
    .table-header {
      display: flex;
      padding: 6px;
      // color: #999;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      // border-bottom: 1px solid rgba(116, 255, 190, 0.2);
      // background-color: rgba(96, 252, 178, 0.31);
      flex-shrink: 0;
      gap: 5px;
      margin: 10px 0;
      .col-index {
        width: 30px;
        flex-shrink: 0;
        text-align: left;
      }

      .col-province {
        flex: 1;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #fff;
      }

    //   .col-count {
    //     flex: 1;
    //     text-align: right;
    //   }
    }

    .table-body {
      flex: 1;
      max-height: 100%;
      overflow: hidden;
      position: relative;
      min-height: 0;
     
    }

    .table-content {
      will-change: transform;
      
      &.scrolling {
        animation: scrollUpSmooth linear infinite;
        
        &.paused {
          animation-play-state: paused;
        }
      }
    }
    
    @keyframes scrollUpSmooth {
      0% {
        transform: translateY(0);
      }
      100% {
        transform: translateY(-50%);
      }
    }

    .table-row {
      display: flex;
      padding: 8px 10px;
      transition: background 2s;
      // font-size: 12px;
      color: #74ffbe;
      gap: 5px;
      &:hover {
        background: rgba(116, 255, 190, 0.1);
      }

      .col-index {
        width: 30px;
        flex-shrink: 0;
        text-align: left;
      }

      .col-province {
        flex: 1;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #fff;
      }

    //   .col-count {
    //     flex: 1;
    //     text-align: right;
    //   }
    }
  }

}
</style>

